// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckButton_wrapper__2UJtH","check":"CheckButton_check__2W-y_","isPreview":"CheckButton_isPreview__3-oO-","checked":"CheckButton_checked__W_V6Z"};